module.exports = __webpack_public_path__ + "img/game_main_pc_227_off.a33063b6.png";